import { httpClient } from '../httpClient';
import { apiErrorHandler } from './helpers';

export const postTax = taxInfo => {
  return httpClient
    .post('/admin/tax', taxInfo)
    .then(response => {
      return response;
    })
    .catch(error => {
      return error.response;
    });
};

export const getAllTax = () => {
  return httpClient
    .get('/admin/tax')
    .then(response => response)
    .catch(error => error.response);
};

export const getTax = id => {
  return httpClient
    .get(`/admin/tax/${id}`)
    .then(response => response)
    .catch(error => error.response);
};

export const updateTax = (id, taxInfo) => {
  return httpClient
    .patch(`/admin/tax/${id}`, taxInfo)
    .then(response => response)
    .catch(error => error.response);
};

export const deleteTax = id => {
  console.log(id);
  return httpClient
    .delete(`/admin/tax/${id}`)
    .then(response => response)
    .catch(error => error.response);
};
